/**
 * AddServizioForm — F-009.6. Form per aggiungere un servizio al catalogo
 * (nome, descrizione opzionale, prezzo €). Presentazionale: `onCreate`/`isPending`
 * dall'esterno. Resetta i campi dopo una creazione riuscita (via `key` remount
 * gestito dal chiamante, oppure reset locale su submit).
 */
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface AddServizioFormProps {
  onCreate: (body: { nome: string; descrizione?: string; prezzoEuro: number }) => void;
  isPending?: boolean;
}

export function AddServizioForm({ onCreate, isPending }: AddServizioFormProps) {
  const [nome, setNome] = useState('');
  const [descrizione, setDescrizione] = useState('');
  const [euro, setEuro] = useState('');

  const prezzo = Number(euro.replace(',', '.'));
  const valid = nome.trim() !== '' && euro.trim() !== '' && Number.isFinite(prezzo) && prezzo >= 0;

  function submit() {
    if (!valid || isPending) return;
    onCreate({
      nome: nome.trim(),
      descrizione: descrizione.trim() || undefined,
      prezzoEuro: prezzo,
    });
    setNome('');
    setDescrizione('');
    setEuro('');
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-[1fr_1fr_8rem_auto] sm:items-end">
      <div className="space-y-1.5">
        <Label htmlFor="srv-nome">Nome servizio</Label>
        <Input
          id="srv-nome"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          placeholder="es. Consulenza"
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="srv-descr">Descrizione (facoltativa)</Label>
        <Input
          id="srv-descr"
          value={descrizione}
          onChange={(e) => setDescrizione(e.target.value)}
          placeholder="es. Consulenza telefonica 1h"
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="srv-prezzo">Prezzo (€)</Label>
        <Input
          id="srv-prezzo"
          type="number"
          inputMode="decimal"
          min={0}
          step="1"
          value={euro}
          onChange={(e) => setEuro(e.target.value)}
          placeholder="es. 80"
        />
      </div>
      <Button onClick={submit} disabled={!valid || isPending}>
        Aggiungi
      </Button>
    </div>
  );
}
